<template>
  <div class="exam-guide">
    <SiteHeader />
    <SiteMenu />
    <ExamGuideView v-if="$route.meta.hideExamGuideView" />
    <router-view />
    <SiteFooter />
  </div>
</template>

<script>
import SiteHeader from './SiteComponents/SiteHeader.vue'
import ExamGuideView from './ExamGuideView.vue'
import SiteMenu from './SiteComponents/SiteMenu'
import SiteFooter from './SiteComponents/SiteFooter'

export default {
  name: 'ExamGuide',
  components: {
    SiteHeader,
    ExamGuideView,
    SiteMenu,
    SiteFooter
  }
}
</script>

<style lang="scss">
.exam-guide {
  font-family: 'Exo 2', sans-serif !important;
  position: relative;
}
</style>
